export default __webpack_public_path__ + "assets/img/DSACommissionAnalytics1.11e6e738.svg";